/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow-restricted-names */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { showLoading, hideLoading } from 'react-redux-loading-bar';

export const api = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://forum-api.dicoding.dev/v1',
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('forumAppToken');
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Thread', 'User', 'Leaderboard', 'AuthUser'],
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: '/login',
        method: 'POST',
        body: credentials,
      }),
      transformResponse: (response) => {
        localStorage.setItem('forumAppToken', response.data.token);
      },
      transformErrorResponse: (response) => response.data,
      invalidatesTags: ['AuthUser'],
    }),

    register: builder.mutation({
      query: (regdata) => ({
        url: '/register',
        method: 'POST',
        body: regdata,
      }),
      transformResponse: (response) => response.data.user,
      transformErrorResponse: (response) => response.data,
      invalidatesTags: ['AuthUser'],
    }),

    getCurrentUser: builder.query({
      query: () => '/users/me',
      transformResponse: (response) => response.data.user,
      transformErrorResponse: (response) => response.data,
      providesTags: () => ['AuthUser'],
    }),

    getLeaderboard: builder.query({
      query: () => '/leaderboards',
      async onQueryStarted(undefined, { dispatch, queryFulfilled }) {
        dispatch(showLoading());
        try {
          const { data } = await queryFulfilled;
          dispatch(hideLoading());
        } catch (err) {
          dispatch(hideLoading());
        }
      },
      transformResponse: (response) => response.data.leaderboards,
      providesTags: ['Leaderboard'],
    }),
  }),
});

export const {
  useGetCurrentUserQuery,
  useLoginMutation,
  useRegisterMutation,
  useGetLeaderboardQuery,
} = api;
